<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M22.5 36h-3a1 1 0 000 2h3a1 1 0 000-2z"/><path d="M11 9a2 2 0 00-2 2v42.5a1.5 1.5 0 003 0V43h19v10.5a1 1 0 002 0V21h9v1.68a5.29 5.29 0 00-3.55 2.51 1 1 0 101.73 1 3.25 3.25 0 015.64 0 1 1 0 00.87.5 1 1 0 00.5-.14 1 1 0 00.36-1.37 5.29 5.29 0 00-3.55-2.5V21h8v32.5a1.5 1.5 0 003 0V11a2 2 0 00-2-2zm20 3v7H12v-7zM12 41v-7h19v7zm19-9H12V21h19zm2-13v-7h19v7z"/></svg>